module.exports = function() {
  return new Worker(__webpack_public_path__ + "44f75e2f3cca2f82dc98.worker.js");
};